import { TFunction } from 'i18next';
import { enqueueSnackbar } from 'notistack';
import * as Sentry from '@sentry/react';

const logUnexpectedErrorImpl = (
  extra: Record<string, unknown>,
  message: string,
): void => {
  enqueueSnackbar(message, {
    variant: 'error',
  });
  Sentry.captureMessage('unexpected-error', {
    extra,
  });
};

export const logUnexpectedErrorAndNotifyUserWithTryAgain = (
  t: TFunction<'translation', undefined>,
  extra: Record<string, unknown>,
): void => logUnexpectedErrorImpl(extra, t('common.unknownErrorTryAgain'));

export const logUnexpectedErrorAndNotifyUser = (
  t: TFunction<'translation', undefined>,
  extra: Record<string, unknown>,
): void => logUnexpectedErrorImpl(extra, t('common.unknownError'));
